export const mod = (index:number, count:number) => {
  const q = index % count;

  return q < 0 ? q + count : q;
};
